
import OccupationField from '../../components/OccupationField/OccupationField';
import PagesFooter from '../../components/PagesFooter/PagesFooter';
import PagesHeader from '../../components/PagesHeader/PagesHeader';
import Title from '../../components/Title/Title';
import { usePagesContext } from '../../context/PagesContext';
import { scrollToFieldWithError } from '../../helpers/scrollToFieldWithError';
import { useAppDispatch } from '../../hooks';
import useComponentTracker from '../../hooks/useComponentTracker';
import useDefaultPagesAction from '../../hooks/useDefaultPagesAction';
import usePagesConfig from '../../hooks/usePagesConfig';
import useSetBannerType from '../../hooks/useSetBannerType';
import useTranslation from '../../hooks/useTranslation';
import useValidation from '../../hooks/useValidation';
import { addOrUpdateFormField } from '../../store/applicationform';
import { WizardPageAction } from '../../store/wizard/wizard';

const CoApplicantEmploymentPage = () => {
    useComponentTracker('CoApplicantEmploymentPage');

    const dispatch = useAppDispatch();
    const { coApplicantTotalSections, coApplicantTotalAboutYouPages } = usePagesConfig();
    const { currentPage } = usePagesContext();
    const translate = useTranslation();
    const defaultPagesAction = useDefaultPagesAction();
    const validationErrors = useValidation(['coapplicantEmploymentType']);

    useSetBannerType('bannerOne');

    const onAction = async (action: WizardPageAction) => {
        if (action === 'next' && validationErrors.length) {
            scrollToFieldWithError(validationErrors);
            validationErrors.forEach((validationError) => {
                dispatch(addOrUpdateFormField(validationError));
            });
            return false;
        }

        return defaultPagesAction(action);
    };

    return (
        <>
            <PagesHeader
                actions={['back']}
                onAction={onAction}
                currentPage={currentPage}
                currentSection={0}
                numberOfSections={coApplicantTotalSections}
                numberOfPagesInSection={coApplicantTotalAboutYouPages}
                currentPageInSection={currentPage}
                sectionTitle={translate('field.section.about-you')}
            />
            <Title text={translate('page.employment.title')} />
            <OccupationField
                label={translate('field.applicant-employment-type.label')}
                name={'coapplicantEmploymentType'}
            />
            <PagesFooter
                actions={['next']}
                onAction={onAction}
                currentSection={0}
                numberOfSections={coApplicantTotalSections}
                numberOfPagesInSection={coApplicantTotalAboutYouPages}
                currentPageInSection={currentPage}
                sectionTitle={translate('field.section.about-you')}
            />
        </>
    );
};
export default CoApplicantEmploymentPage;
